(() => {
  const targetPattern = /(don['’]?t\s+like\s+(our|the)\s+price|make\s+an\s+offer)/i;
  const desired = 'Request Private Pricing';

  // Hide the button on pieces priced below the threshold set in the Masha PDP Signals section.
  function belowThreshold() {
    const pdp = window.MashaPDP;
    return !!(pdp && pdp.price > 0 && pdp.privateMin > 0 && pdp.price < pdp.privateMin);
  }

  function renamePrivatePricing(root = document) {
    const hide = belowThreshold();
    const candidates = root.querySelectorAll ? root.querySelectorAll('button, a, [role="button"]') : [];
    candidates.forEach((el) => {
      const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text || text.length > 140 || !targetPattern.test(text)) return;
      if (hide) {
        el.style.display = 'none';
        el.setAttribute('aria-hidden', 'true');
        return;
      }
      if (text === desired) return;
      el.textContent = desired;
      el.setAttribute('aria-label', desired);
      el.classList.add('masha-private-pricing');
    });
  }

  const run = () => renamePrivatePricing(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.('button, a, [role="button"]')) renamePrivatePricing(node.parentElement || document);
        else renamePrivatePricing(node);
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
